export enum EDefaultUserSettingRoute {
  ALL_LEADS = 'all-leads',
  DASHBOARD = '/',
}
